import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';
import { evaluationMessages } from '@/shared/config';

import { DocumentSections } from '../../DocumentSections/DocumentSections';
import styles from '../../EncounterDetails.module.scss';
import { EvaluationSections } from '../../EvaluationSections/EvaluationSections';
import { EncounterTab } from '../../hooks';
import { TranscriptView } from '../../TranscriptView/TranscriptView';

type EncounterTabPanelProps = {
  activeTab: EncounterTab | undefined;
  canViewEvaluation: boolean;
  encounter: TranscriptorEncounterResponse;
};

export const EncounterTabPanel: FC<EncounterTabPanelProps> = (props) => {
  const { activeTab, canViewEvaluation, encounter } = props;

  if (activeTab?.kind === 'document') {
    if (activeTab.document.type === 'evaluation') {
      // Scribe strips the sections it does not grant, so without this the tab
      // would render empty instead of saying why.
      if (!canViewEvaluation) {
        return (
          <div className={styles.empty}>
            <FormattedMessage {...evaluationMessages.accessRestricted} />
          </div>
        );
      }

      return (
        <EvaluationSections sections={activeTab.document.sections ?? []} />
      );
    }

    return <DocumentSections sections={activeTab.document.sections ?? []} />;
  }

  if (activeTab?.kind === 'transcript') {
    return <TranscriptView fragments={encounter.fragments ?? []} />;
  }

  return null;
};
